const TABS_HEIGHT = 48;
const HISTORY_FILTERS_HEIGHT = 150;
const INTERVENTIONS_FILTERS_HEIGHT = 48;
const INTERVENTIONS_TABS_HEIGHT = 128;
export {
  TABS_HEIGHT,
  HISTORY_FILTERS_HEIGHT,
  INTERVENTIONS_FILTERS_HEIGHT,
  INTERVENTIONS_TABS_HEIGHT,
};
